export default __webpack_public_path__ + "static/media/investor-presentation.4b84fbad.pdf";